import { getUSCurrency } from "@/global/utils/getUSCurrency";
import { SubtotalListItem } from "./SubtotalListItem";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useAppStore } from "@/global/store/store";
import { selectCartManager } from "@/global/store/data/purchaseSeats/cartManager";

export function ServiceFeeSubtotals(props: {
  basePrice: number;
  allInPrice: number;
  perkTotalPrice: number;
  cartOrderServiceFee: number;
  processingFee: number;
}) {
  const { uiConfigs } = useTeamConfig();
  const cartState = useAppStore(selectCartManager);

  // values
  const {
    basePrice,
    allInPrice,
    perkTotalPrice,
    cartOrderServiceFee,
    processingFee,
  } = props;

  // labels and languages
  const ticketTotalLabel = uiConfigs?.checkoutPerkSubtotals?.ticketTotalLabel || "Package Balance"; // prettier-ignore
  const orderServiceFeeLabel = uiConfigs?.checkoutPerkSubtotals?.serviceFeeLabel || "Service Fees"; // prettier-ignore
  const totalBalanceLabel = uiConfigs?.checkoutPerkSubtotals?.totalBalanceLabel || "Total Balance"; // prettier-ignore
  function renderPerkTotalLabel() {
    const perkTotalLabel = uiConfigs?.checkoutPerkSubtotals?.perkTotalLabel;
    if (typeof perkTotalLabel == "undefined") return "Add Ons Balance";
    if (typeof perkTotalLabel == "string") return perkTotalLabel;
    return perkTotalLabel(cartState);
  }

  return (
    <>
      {cartOrderServiceFee > 0 ? (
        <>
          <SubtotalListItem
            label={ticketTotalLabel}
            value={getUSCurrency(basePrice)}
          />

          {perkTotalPrice > 0 ? (
            <SubtotalListItem
              label={renderPerkTotalLabel()}
              value={getUSCurrency(perkTotalPrice)}
            />
          ) : null}

          <SubtotalListItem
            label={orderServiceFeeLabel}
            value={getUSCurrency(cartOrderServiceFee)}
          />

          <SubtotalListItem
            label={totalBalanceLabel}
            value={getUSCurrency(allInPrice)}
          />
        </>
      ) : (
        <SubtotalListItem
          label="Total Balance"
          value={getUSCurrency(allInPrice)}
        />
      )}

      {processingFee > 0 ? (
        <SubtotalListItem
          label="Processing Fee"
          value={getUSCurrency(processingFee)}
        />
      ) : null}
    </>
  );
}
